import React from "react";
import { Row, CardImg } from "reactstrap";
import Noimage from "assets/images/product/noimage.jpg";

const DPImage = ({ rowClass, labelText, onClick, style }) => {
  const defaultStyle = {
    maxWidth: "100%",
    height: "100px", // Set a fixed height
    width: "auto",
  };

  return (
    <Row className={rowClass}>
      <div className="input-group">
        <CardImg
          src={labelText}
          alt={labelText}
          className="rounded avatar-lg"
          onClick={onClick}
          style={{ ...defaultStyle, ...style }}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = Noimage;
          }}
        />
      </div>
    </Row>
  );
};

export default DPImage;
